// ================================
// export components
// ================================
import hello from './Hello'

export default [
  hello
]



// WEBPACK FOOTER //
// ./src/components/index.js